// extracted by mini-css-extract-plugin
export var container = "_cv-0";
export var containerTopRight = "_cv-1";